export const LeadRawStatus = {
  Demo: "demo",
  Lead_1: "lead_1",
  Lead_2: "lead_2",
  Lead_4: "lead_4",
  Lead_5: "lead_5",
  Approved: "client",
  Unknown: "unknown",
} as const;
